// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-direction: column;
}

.second-level-menu {
  background: #fff;
  height: 100%;
  max-height: 92vh;
  width: calc(100% - 30px) !important;
  margin: 10px auto;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/staff-room/staff-room.components.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AACA;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,uCAAA;EACA,wCAAA;AAEJ","sourcesContent":[":host{\n    flex-direction: column;\n}\n.second-level-menu{\n    background: #fff;\n    height: 100%;\n    max-height: 92vh;\n    width: calc(100% - 30px) !important;\n    margin: 10px auto;\n    border-top-left-radius: 10px !important;\n    border-top-right-radius: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
